import { Component }              from '@angular/core';
import { MatDialogRef }            from '@angular/material';
import { Globals }                from './../common/globals';
import { SupplierModel }          from './supplier.model';

@Component({
  selector: 'sa-supplier-dialog',
  template: require('./supplier-dialog.component.html'),
  styles: [require('./supplier-dialog.component.scss')]
})
export class SupplierDialogComponent {

  public newItem = false;
  public model: SupplierModel;

  public logoUrl: string;
  public antiCache: string;

  private errors = [];

  constructor(public dialogRef: MatDialogRef<SupplierDialogComponent>, public globals: Globals) {
    this.antiCache = new Date().getTime() + '';
  }

  delete() {
    if (confirm('Opravdu si přejete odstranit tento záznam?\nTato změna je nevratná.')) {
      this.dialogRef.close('delete');
    }
  }

  save() {
    this.errors = [];
    if (!this.model.companyName || this.model.companyName.trim().length === 0) {
        this.errors.push('Vyberte prosím název firmy dodavatele');
    }
    if (!this.model.companyLin || this.model.companyLin.trim().length === 0) {
        this.errors.push('Zadejte prosím IČ dodavatele');
    }
    if (!this.model.companyTin || this.model.companyTin.trim().length === 0) {
        this.errors.push('Zadejte prosím DIČ dodavatele');
    }
    if (this.model.supplierId === null || isNaN(this.model.supplierId) || this.model.supplierId % 1 !== 0 ||
        this.model.supplierId < 0  || this.model.supplierId > 2147483647) {
        this.errors.push('Zadejte prosím platné číslo dodavatele');
    }
    if (this.errors.length === 0) {
      this.model.businessType = this.globals.portalType;
      this.dialogRef.close('save');
    }
  }
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/@angularclass/hmr-loader!./node_modules/tslint-loader!./src/app/supplier-dialog/supplier-dialog.component.ts